import { UseRefetchMaterialitiesDocument } from '@/graphql/generated';

import { useProjectContext } from '@/providers/ProjectContextProvider';

export const useRefetchMaterialities = () => {
  const projectContext = useProjectContext();
  return [
    {
      query: UseRefetchMaterialitiesDocument,
      variables: {
        id: projectContext?.enterprise?.referential?.id || '',
      },
    },
  ];
};
